import type { Query } from "@rocicorp/zero";
import type { Schema } from "./generatedDrizzleSchema";

// `after` must carry every ordering column, including the primary-key columns
// ZQL appends; a missing one compares as NULL and repeats the boundary row.
export function paginateQuery<
  TTable extends keyof Schema["tables"] & string,
  TReturn,
>(
  query: Query<TTable, Schema, TReturn>,
  page:
    | {
        limit?: number;
        after?: Parameters<Query<TTable, Schema, TReturn>["start"]>[0];
      }
    | undefined
) {
  let paged = query;
  if (page?.after) paged = paged.start(page.after);
  if (page?.limit !== undefined) paged = paged.limit(page.limit);
  return paged;
}
